import type { UseCurrencyReturn } from "@app/interfaces/useCurrency.interface";
import { useEventSender } from '@composables/useEventSender';
import { useSearchStore } from '@stores/useSearchStore';
import { useEventAggregationDependencies } from "./useEventAggregationDependencies";
import { EVENT_TYPES } from "@app/interfaces/useEventAggregation.interface";
import { computed } from "vue";

export const useCurrency = (): UseCurrencyReturn => {
	const searchStore = useSearchStore();

	const changeCurrency = (): void => {
		useEventSender().sendChangeCurrencyEvent();
	};

	const updateUserCurrency = async (currency: string): Promise<void> => {
		await searchStore.processCurrencyOrNationalityChange(undefined, currency);
	}

	const currencyConvert = async (amount: number, fromCurrency: string, toCurrency: string): Promise<number> => {
		if (searchStore.currencyConversionService.convert)
			return await searchStore.currencyConversionService?.convert(amount, fromCurrency, toCurrency);
		return amount;
	}

	const userCurrency = computed(() => searchStore.userCurrency);

	useEventAggregationDependencies({
		waitFor: [EVENT_TYPES.ProfileQuestionnairesReady],
		onReady: () => {
			searchStore.setProfileQuestionnairesReady(true);
		},
	});

	const triggerCurrencyChange = (): void => {
		if (!searchStore.isProfileQuestionnairesReady) return;
		changeCurrency();
	};

	return {
		triggerCurrencyChange,
		userCurrency,
		isProfileQuestionnairesReady: searchStore.isProfileQuestionnairesReady,
		updateUserCurrency,
		currencyConvert,
		changeCurrency
	};
}